__turbopack_context__.v({
  "toolkit-item-card": "KqJQwa_toolkit-item-card",
  "toolkit-item-card__actions-container": "KqJQwa_toolkit-item-card__actions-container",
  "toolkit-item-card__icon": "KqJQwa_toolkit-item-card__icon",
  "toolkit-item-card__image": "KqJQwa_toolkit-item-card__image",
  "toolkit-item-card__title": "KqJQwa_toolkit-item-card__title",
});
